import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocationService } from '../services/location/location.service';
import { Platform  } from '@ionic/angular';
import { NgZone } from '@angular/core';
import { ApiService } from '../services/api/api.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-restaurants',
  templateUrl: './restaurants.page.html',
  styleUrls: ['./restaurants.page.scss'],
})


export class RestaurantsPage implements OnInit {
  noStoresAvail = false
  categories = [];
  highlights = [];
  featured = [];

  catSlideOpts = {
    freeMode: true,
    slidesPerView: 3.5,
    slidesOffsetBefore: 11,
    spaceBetween: 10
  };

  highlightSlideOpts =  {
    slidesPerView: 1.05,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true
  };

  featuredSlideOpts = {
    slidesPerView: 1.2,
    spaceBetween: 10,
    freeMode: true
  };

  showLocationDetail = false;
  myLocation:any = {
    lat : '',
    lng : '',
    address: ''
  }

  showLocationMsg:any = false
  searchKey:any = ''
  storeDataTemp:any = []
  noImageAvailable:any = '../assets/img/No_Image_Available.jpg'
  constructor(private router: Router,private api :ApiService,private zone: NgZone,private platform: Platform,private http: HttpClient,public locationService: LocationService) { }

  async ngOnInit() {
    this.zone.run(()=>{
      this.platform.ready().then(async () => {
          let locationData: any = await this.locationService.checkGPSPermission()
          console.log(locationData)
      })

      this.api.getaddress().subscribe((address: any)=>{
        if(address != ''){
          this.myLocation.address = address
          localStorage.setItem('address',address)
          setTimeout(()=>{
            this.getStoreDataByLatLang()
          },1000)
        }
      })

      this.api.getlatitude().subscribe((lat: any)=>{
        if(lat != ''){
          this.myLocation.lat = lat
          localStorage.setItem('latitude',JSON.stringify(JSON.parse(lat)))
        }
      })

      this.api.getlongitude().subscribe((lng: any)=>{
        if(lng != ''){
          this.myLocation.lng = lng
          localStorage.setItem('longitude',JSON.stringify(JSON.parse(lng)))
        }
      })
      
      this.api.getLocationErr().subscribe((err: any)=>{
        if(err == true){
          this.showLocationMsg = true
        }
      })
      // this.http.get('https://devdactic.fra1.digitaloceanspaces.com/foodui/home.json').subscribe((res: any) => {
      //   console.log((res));
      //   this.categories = res.categories;
      //   this.highlights = res.highlights;
      //   this.featured = res.featured;
      // });
    })
  }

  setFilteredItems(){
    if(this.searchKey == ''){
      this.featured =  this.storeDataTemp
      if(this.featured.length == 0){
        this.noStoresAvail = true
      }
    }
    else {
      this.featured =  this.storeDataTemp.filter((obj: any) =>{
        return obj.store_name.toLowerCase().search(this.searchKey.toLowerCase()) != -1;
      });
      if(this.featured.length == 0){
        this.noStoresAvail = true
      }
    }
  }

  resetSearch(){
    this.noStoresAvail = false
    if(this.myLocation.lat && this.myLocation.lng){
      this.api.getStoreListByLatLng({"latitude":this.myLocation.lat, "longitude": this.myLocation.lng}).subscribe((result:any) => {
        if(result.status == true){
            if(result.data.near_by_stores.length > 0){
                this.storeDataTemp = result.data.near_by_stores;
                this.featured = result.data.near_by_stores;
            }
            if(result.data.near_by_stores == 0){
              this.featured = []
              this.noStoresAvail = true
            }
          }
          else {
            this.showLocationMsg = true
          }
        },(err)=>{
          this.showLocationMsg = true
        })
      }
      else {
        this.showLocationMsg = true
      }
  }

  getMyLocation(){
    this.zone.run(()=>{
      this.platform.ready().then(async () => {
      let locationData: any = await this.locationService.checkGPSPermission()
      console.log(locationData)
      })
    })
  }

  getStoreDataByLatLang() {
    this.showLocationMsg = false
    this.noStoresAvail = false
    if(this.myLocation.lat && this.myLocation.lng){
      this.api.getStoreListByLatLng({"latitude":this.myLocation.lat, "longitude": this.myLocation.lng}).subscribe((result:any) => {
        if(result.status == true){
            if(result.data.store_banners.length > 0){
                this.highlights = result.data.store_banners;
            }
            else{
              this.highlights = []
            }
            if(result.data.near_by_stores.length > 0){
                this.storeDataTemp = result.data.near_by_stores;
                this.featured = result.data.near_by_stores;
                localStorage.setItem('near-by-stores',JSON.stringify(this.featured))
                console.log(this.featured)
            }
            else if(result.data.near_by_stores.length == 0){
              this.storeDataTemp = []
              this.featured = []
              this.noStoresAvail = true
            }
          }
          else {
            this.showLocationMsg = true
          }
        },(err)=>{
          this.showLocationMsg = true
        })
      }
      else {
        this.showLocationMsg = true
      }
    }



  // updateLocation(){
  //     let latlng: any = JSON.parse(localStorage.getItem('current-location') || '[]')
  //     if(latlng.length > 0){
  //       this.myLocation = latlng[0]
  //     }
  // }

  doRefresh(ev) {
    this.noStoresAvail = false
    setTimeout(() => {
      if(this.myLocation.lat && this.myLocation.lng){
        this.api.getStoreListByLatLng({"latitude":this.myLocation.lat, "longitude": this.myLocation.lng}).subscribe((result:any) => {
          if(result.status == true){
              if(result.data.store_banners.length > 0){
                  this.highlights = result.data.store_banners;
              }
              else{
                this.highlights = []
              }
              if(result.data.near_by_stores.length > 0){
                  this.storeDataTemp = result.data.near_by_stores;
                  this.featured = result.data.near_by_stores;
                  console.log(this.featured)
              }
              else if(result.data.near_by_stores.length == 0){
                this.storeDataTemp = []
                this.featured = []
                this.noStoresAvail = true
              }
              ev.target.complete();
            }
            else {
              this.showLocationMsg = true
              ev.target.complete();
            }
          },(err)=>{
            this.showLocationMsg = true
            ev.target.complete();
          })
        }
        else {
          this.showLocationMsg = true
          ev.target.complete();
        }
    }, 500);
  }

  onScroll(ev) {
    const offset = ev.detail.scrollTop;
    this.showLocationDetail = offset > 50;
  }

  goToStorePage(store: any){
    localStorage.setItem('subscriber_id',store.subscriber)
    localStorage.setItem('store-name',store.store_name)
    localStorage.setItem('store-info',JSON.stringify(store))
    this.router.navigate(['/home/'+store.id])
  }

  bannerToStorePage(storebanner: any){
    this.router.navigate(['/home/'+storebanner.store])
  }

}
